import GiftTab from "../../GiftTab.js";
import DonationTab from "../../DonationTab.js";
import RecurringDonationTab from "../../RecurringDonationTab.js";
import ManualRecurringDonationTab from "../../ManualRecurringDonationTab.js";
import FollowUpRemarkTab from "../../FollowUpRemarkTab.js";
import OtherAccount from "../../OtherAccount.js";
import DonorFormFields from "./DonorFormFields.js";

function UserDetailsModal({
  isEditMode,
  isEditable,
  activeTab,
  setActiveTab,
  editModeOn,
  currentUserId,
  currentPhoneNumber,
  handleSubmit,
  userDetailsFormData,
  handleUserDetailsChange,
  agencies,
  agenciesLoading,
  modes,
  modesLoading,
  mentors,
  mentorsLoading,
  handleMentorSelect,
  closeModal,
  role,
}) {
  return (
    <div
      className="modal fade"
      id="editModal"
      tabIndex="-1"
      aria-labelledby="newUserModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-fullscreen">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="newUserModalLabel">
              {role === "mentor"
                ? "View Donor Details"
                : isEditMode
                ? "Edit Donor"
                : "Add Donor"}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>

          <div className="modal-body">
            {isEditMode && !isEditable && (
              <div className="d-flex justify-content-between align-items-center mt-2 mb-3">
                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <button
                      className={`nav-link ${
                        activeTab === "User Details" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("User Details")}
                    >
                      User Details
                    </button>
                  </li>
                  {role !== "mentor" && (
                    <>
                      <li className="nav-item">
                        <button
                          className={`nav-link ${activeTab === "gifts" ? "active" : ""}`}
                          onClick={() => setActiveTab("gifts")}
                        >
                          Gifts
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className={`nav-link ${
                            activeTab === "donations" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("donations")}
                        >
                          Manual Donations
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className={`nav-link ${
                            activeTab === "Recurring donation" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("Recurring donation")}
                        >
                          Auto Recurring Donation
                        </button>
                      </li>
                    </>
                  )}
                  {/* <li className="nav-item">
                    <button
                      className={`nav-link ${
                        activeTab === "Follow Up Remarks" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("Follow Up Remarks")}
                    >
                      Follow Up Remarks
                    </button>
                  </li> */}
                  {/* <li className="nav-item">
                    <button
                      className={`nav-link ${
                        activeTab === "Other Account" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("Other Account")}
                    >
                      Other Account
                    </button>
                  </li> */}
                </ul>

                <div>
                  {role !== "mentor" && activeTab === "User Details" && (
                    <button
                      type="button"
                      className="btn btn-dark btn-round ms-3"
                      onClick={editModeOn}
                    >
                      Edit Donor
                    </button>
                  )}
                </div>
              </div>
            )}

            {role !== "mentor" && activeTab === "gifts" ? <GiftTab donor_id={currentUserId} /> : ""}
            {role !== "mentor" && activeTab === "donations" ? (
              <DonationTab donor_id={currentUserId} />
            ) : (
              ""
            )}
            {role !== "mentor" && activeTab === "Recurring donation" ? (
              <RecurringDonationTab donor_id={currentUserId} />
            ) : (
              ""
            )}
            {activeTab === "Manual Recurring donations" ? (
              <ManualRecurringDonationTab donor_id={currentUserId} />
            ) : (
              ""
            )}
            {activeTab === "Follow Up Remarks" ? (
              <FollowUpRemarkTab donor_id={currentUserId} />
            ) : (
              ""
            )}
            {activeTab === "Other Account" ? (
              <OtherAccount
                donor_id={currentUserId}
                current_phone_number={currentPhoneNumber}
              />
            ) : (
              ""
            )}

            {activeTab === "User Details" ? (
              <form
                onSubmit={handleSubmit}
                className={`${
                  isEditMode && !isEditable
                    ? "not-editable-modal"
                    : "editable-modal"
                }`}
              >
                <DonorFormFields
                  userDetailsFormData={userDetailsFormData}
                  handleUserDetailsChange={handleUserDetailsChange}
                  agencies={agencies}
                  agenciesLoading={agenciesLoading}
                  modes={modes}
                  modesLoading={modesLoading}
                  mentors={mentors}
                  mentorsLoading={mentorsLoading}
                  handleMentorSelect={handleMentorSelect}
                  role={role}
                />
                {role !== "mentor" && isEditMode && isEditable && (
                  <button
                    type="submit"
                    className="btn btn-primary btn-round btn-sm"
                  >
                    Update Donor
                  </button>
                )}

                {role !== "mentor" && !isEditMode && (
                  <button
                    type="submit"
                    className="btn btn-primary btn-round btn-sm"
                  >
                    Add Donor
                  </button>
                )}
              </form>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserDetailsModal;
